export default {
    login: 'Fazer Login',
    signUp: 'Cadastre-se',
    continue: 'Continuar',
    loginWith: 'Login com',
    signUpButton: 'Cadastrar',
    haveLogin: 'Já tenho cadastro',
    signUpEmail: 'Cadastro por E-mail',
    loginAstrolink: 'Entrar no Astrolink',
    googleError: 'Algo inesperado aconteceu, por favor tente novamente.',
    emailConsentiment: 'Desejo receber e-mail sobre horóscopo, promoções e novos conteúdos.',
    emailConsentimentNestle: 'Desejo receber e-mail sobre horóscopo, e novos conteúdos de Astrolink e Nestlé.',
    haveLoginMarketing: '<span>Já tem um cadastro? <a href="http://www.astrolink.com.br">Faça login</a></span>',
    termsConsentiment: '<span>Concordo com os <a href={termsLink} class="auth__app-link" rel="noopener noreferrer" target="_blank">Termos de uso</a> e a <a href={privacyLink} class="auth__app-link" rel="noopener noreferrer" target="_blank">Política de privacidade</a> do Astrolink.</span>',
    termsConsentimentNestle: '<span>Concordo com o <a href={regulation} class="auth__app-link" rel="noopener noreferrer" target="_blank">Regulamento da Promoção</a>, os <a href={termsLink} class="auth__app-link" rel="noopener noreferrer" target="_blank">Termos de Uso</a> e a <a href={privacyLink} class="auth__app-link" rel="noopener noreferrer" target="_blank">Política de privacidade</a> do Astrolink.</span>',
    revokeApplePermissions: `
        <p>Tivemos um problema ao acessar as informações da sua conta apple. Por favor revogue as permissões de acesso do Astrolink</p>
        <p>Saiba como fazer isso, <a href="https://support.apple.com/pt-br/HT210426" target="_blank">clicando aqui.</a></p>`,

    consentModal: {
        acceptButton: 'Aceito',
        title: 'Para prosseguir com seu cadastro é necessário concordar com os termos de uso e política de privacidade do Astrolink, marcando a opção abaixo',
    },

    forgotPassword: {
        title: 'Esqueceu sua senha?',
        button: 'Recuperar Senha',
        successTitle: 'Verifique seu e-mail!',
        error: 'Ocorreu um erro ao recuperar sua senha',
        description: 'Informe o seu e-mail para recuperar a sua senha.',
        notFound: 'Não conseguimos encontrar uma conta com essas informações',
        successMessage: 'Altere sua senha acessando o link que enviamos e continue sua jornada!',
    },

    forgotPasswordFacebook: {
        title: 'Atenção: o acesso via Facebook foi descontinuado!',
        button: 'Criar nova senha',
        footer: 'Se estiver com problemas para acessar a sua conta, <a href={contactUrl}>entre em contato</a>',
        inputEmail: 'Digite o e-mail vinculado à conta Facebook que foi cadastrada no Astrolink e em seguida em Criar Nova Senha',
        description: 'Vamos recuperar sua conta? Você precisará criar uma nova senha para o endereço anteriormente cadastrado via Facebook.'
    },

    facebookError: {
        title: 'Ops! Parece que você já possui uma conta no Astrolink com este e-mail.',
        description: 'Tente acessar o site com seu e-mail e senha, se não lembrar sua senha selecione a opção "Esqueceu sua senha?". Se necessário, entre em <a href={link}>contato</a> conosco.',
        emailForbidden: 'Desculpe, não foi possível fazer login usando a sua conta do Facebook porque pode existir uma conta registrada com o mesmo endereço de e-mail. Por favor, faça login usando suas credenciais ou redefina sua senha. Se precisar de ajuda adicional, entre em contato com nossa equipe de suporte.',
        loginForbidden: 'A permissão de acesso ao facebook nao foi concedida.',
        appForbidden: 'Algo inesperado aconteceu, por favor tente novamente.',
        emailDeleted: 'E-mail inválido',
    },

    placeholder: {
        gender: 'Gênero',
        password: 'Senha',
        name: 'Nome Completo',
        email: 'E-mail',
    },

    genderOptions: {
        male: 'Masculino',
        female: 'Feminino',
        notBinary: 'Não binário'
    },

    carousel: {
        main: {
            title: 'A maior plataforma de Astrologia e autoconhecimento do Brasil'
        },
        birthchart: {
            title:'Mapa Astral Grátis',
            description:'Comece a sua jornada astrológica descobrindo mais sobre você'
        },
        horoscope: {
            title:'Ciclo Lunar e Biorritmo',
            description:'Veja como os ciclos da natureza influenciam seu dia-a-dia'
        },
        compatibility: {
            title:'Compatibilidade Astral',
            description:'Entenda como se relacionar melhor com as pessoas ao seu redor'
        },
        tarot: {
            title:'Tarot',
            description:'Consulte as cartas quando estiver em busca de respostas'
        },
        login: 'Já tenho uma conta',
        signUp: 'Quero me cadastrar',
        signUpGoogle: 'Cadastro via Google',
        signUpApple: 'Cadastro via Apple',
        signUpEmail: 'Cadastro via E-mail',
    },

    errors: {
        invalidEmail: '^E-mail inválido',
        nameEmpty: '^Nome não informado',
        genderEmpty: '^Gênero não informado',
        passwordLength: '^Senha muito fraca',
        nameFormat: '^Utilize apenas letras',
        nameLength: '^Mínimo de 3 caracteres',  
        passwordEmpty: '^Senha não informada',
        default: 'E-mail ou senha inválidos',
        emailEmpty: '^E-mail não foi informado',
        genderReferenceEmpty: 'Referência não informada',
        googleAccount: 'Clique no botão "Login com Google" para prosseguir com seu login',
        appleAccount: 'Clique no botão "Login com Apple" para prosseguir com seu login',
        tooManyAttempts: 'Número de tentativas excedido, tente novamente em alguns minutos',
        locked: 'Não conseguimos validar seu e-mail. Por favor, entre em contato com suporte e forneça o código de erro: #028.',
    },

    help: {
        and: 'e a',
        termsLink: 'termos',
        terms: 'Termos de uso ',
        privacyLink: 'privacidade',
        onAstrolink: ' do Astrolink.',
        privacy: ' Política de privacidade',
        onCreate: 'Ao criar uma conta, você concorda com os ',
    },

    errorModal: {
        understood: 'Entendi',
        title: 'Tivemos um problema ao processar seu login.',
        generic: 'Algo inesperado aconteceu, por favor tente novamente.',
    },

    contactUs: {
        link: 'https://suporte.astrolink.com.br/hc/pt-br',
        title: 'Entre em contato conosco'
    },

    signUpError: {
        invalidName: 'Nome inválido',
        invalidEmail: 'E-mail inválido',
        invalidPassword: 'Senha inválida',
        alreadyExist: 'E-mail já cadastrado'
    }
};